import React from "react";
import Modal, { ModalTransition } from "@atlaskit/modal-dialog";
import apiClient from "../../api/admin-api-client";
import { toast } from "react-toastify";
import useAsync from "../../hooks/use-async";
import { useTranslation } from "react-i18next";

export default function RemoveRelation({ relation, onRemoved, onClose }) {
    const { t } = useTranslation();
    const { run, isPending } = useAsync();
    const remove = () => {
        run(apiClient(`document-type/${relation.document_type_id}/link/${relation.can_link_to_document_type_id}`, { method: "DELETE"}))
            .then(() => {
                toast.success(t("admin_remove_relation_success"));
                onRemoved && onRemoved();
            })
            .catch(error => toast.error(t("admin_remove_relation_error") +  error.message));
    };

    return (
        <>
            <ModalTransition>
                <Modal
                    isLoading={isPending}
                    actions={[
                        { text: t("admin_remove_relation_remove"), onClick: remove, isLoading: isPending },
                        { text: t("admin_remove_relation_cancel"), onClick: onClose, isDisabled: isPending },
                    ]}
                    onClose={close}
                    heading={t("admin_remove_relation_heading")}
                    appearance="danger"
                >
                    <p>
                        {t("admin_remove_relation_heading_p")}
                    </p>
                </Modal>
            </ModalTransition>
        </>
    );
}